module.exports = __webpack_public_path__ + "img/2022_the_lakes_cover.3244b25e.png";